var _defs, _rect, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2BInvite4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    role: "img",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b2bInvite4Sky",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ead9c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#c7a27a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3a2f28"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#b2bInvite4Sky)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 160,
    r: 140,
    fill: "#fff4e6",
    opacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M700 900 C 760 520 900 260 1120 200 C 1240 340 1180 620 1280 900 Z",
    fill: "#f6eee4",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 700 C 220 620 440 760 700 640 C 980 520 1240 700 1600 600 L 1600 900 L 0 900 Z",
    fill: "#2a221c",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BInvite4);
export default __webpack_public_path__ + "static/media/b2b-invite-4.b88960d0da8f7e757176aed02fcafa0c.svg";
export { ForwardRef as ReactComponent };